import { Scale, Shield, Headphones, FileCheck, CheckCircle2, Award } from 'lucide-react';
import { Button } from './ui/button';
import { motion } from 'framer-motion';
import { Reveal } from './motion/Reveal';
import { StaggerGroup, StaggerItem } from './motion/Stagger';

const MotionButton = motion(Button);

export const Services = () => {
  const services = [
    {
      icon: Scale,
      title: 'A gente só defende o trabalhador',
      description: 'Nosso time não defende empresa nem patrão. A gente luta com unhas e dentes pra você receber cada real que te devem.',
      features: ['Conta feita no detalhe', 'Cobrança de tudo o que sumiu', 'Defesa firme do seu lado'],
    },
    {
      icon: Shield,
      title: 'Você não gasta nem um centavo',
      description: 'Zero custo pra começar. A gente não cobra nada adiantado e você só paga uma parte se o dinheiro cair na sua mão.',
      features: ['Consulta 100% de graça', 'Sem pegadinhas', 'Só paga se ganhar'],
    },
    {
      icon: Headphones,
      title: 'Gente de verdade no WhatsApp',
      description: 'Nada de robô enrolando! Você conversa com a nossa equipe direto no celular e tira qualquer dúvida na hora.',
      features: ['Conversa rápida e simples', 'Avisamos tudo sobre o caso', 'Sempre à disposição'],
    },
    {
      icon: FileCheck,
      title: 'Resolve tudo pelo celular',
      description: 'Você não precisa ir a cartório, não precisa faltar no trabalho novo e resolve tudo mandando foto dos documentos.',
      features: ['Manda tudo pelo Zap', 'Sem papelada chata', 'Audiências pela internet'],
    },
  ];

  const scrollToContact = () => {
    const element = document.querySelector('#contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="py-20 bg-slate-50"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <Reveal delay={0.1} className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold mb-4">
            <Award className="w-4 h-4" />
            <span>Por que escolher a gente?</span>
          </div>
          <h2
            data-testid="services-title"
            className="text-3xl md:text-4xl font-bold text-slate-900 mb-4"
          >
            A gente faz a parte difícil por você
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Você segue com a sua vida e a gente corre atrás do seu dinheiro. Sem dor de cabeça, sem complicação.
          </p>
        </Reveal>

        {/* Services Grid */}
        <StaggerGroup staggerDelay={0.1} startDelay={0.2} className="grid md:grid-cols-2 gap-6 mb-12">
          {services.map((service, index) => (
            <StaggerItem
              key={index}
              data-testid={`service-card-${index}`}
              className="bg-white p-8 rounded-2xl border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_-15px_rgba(37,99,235,0.25)] hover:border-blue-200 transition-all duration-500 ease-[cubic-bezier(0.23,1,0.32,1)] hover:-translate-y-2"
            >
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-blue-600 rounded-xl flex items-center justify-center shrink-0">
                  <service.icon className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 mb-4 leading-relaxed text-sm">
                    {service.description}
                  </p>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center gap-2 text-sm text-slate-700">
                        <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" />
                        <span className="font-medium">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>

        {/* Bottom CTA */}
        <Reveal delay={0.4} className="text-center">
          <MotionButton
            data-testid="services-cta"
            onClick={scrollToContact}
            size="lg"
            whileHover={{ y: -8 }}
            whileTap={{ scale: 0.97 }}
            className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-8 py-5 h-auto text-base font-bold shadow-lg shadow-blue-600/30 transition-shadow duration-500"
          >
            Quero Minha Avaliação Grátis
          </MotionButton>
        </Reveal>
      </div>
    </section>
  );
};
